import { AssetFluid } from './asset'
import { ImageInsert, RichText } from './post'
import { Brand } from './brand'
import { VideoInsert } from './video'
import { CssEntry } from './contentfulAttributes'

export type deviceType = 'Desktops' | 'Tablets' | 'Laptops' | 'Mobiles'
export type HideOn = Array<deviceType> | null

export type HeroTextSection = {
  __typename: 'ContentfulHeroTextSection'
  id: string
  contentful_id: string
  name: string
  subtitle: string
  backgroundColor: BGVariants
  body: RichText
  brand: Brand
  variant: HTSVariants
  hideOn: HideOn
  codeClasses: string[] | null
  paddingUpdate: 'ZeroTopPadding' | 'ZeroBottomPadding' | 'ZeroTopBottomPadding'
  css: CssEntry[] | null
}

export type HeroTextTwoColumnSection = {
  __typename: 'ContentfulHeroTextTwoColumnSection'
  id: string
  contentful_id: string
  name: string
  subtitle: string
  backgroundColor: BGVariants
  column1Alignment: AlignmentVariants
  column1: RichText
  column2Alignment: AlignmentVariants
  column2: RichText
  brand: Brand
  variant: HTSVariants
  codeClasses: string[] | null
  paddingUpdate: 'ZeroTopPadding' | 'ZeroBottomPadding' | 'ZeroTopBottomPadding'
  css: CssEntry[] | null
  hideOn: HideOn
}
export type HorizontalSplit2ColumnSection = {
  __typename: 'ContentfulHorizontalSplit2ColumnSection'
  id: string
  contentful_id: string
  name: string
  column1TopContentAlignment: AlignmentVariants
  column1TopContent: RichText
  column1BottomContentAlignment: AlignmentVariants
  column1BottomContent: RichText
  column2ContentAlignment: AlignmentVariants
  column2Content: RichText
  backgroundColorTop: BGVariants
  backgroundColorBottom: BGVariants
  codeClasses: string[] | null
  hideOn: HideOn
}

export enum HTSVariants {
  Centered = 'Centered',
  Column = 'Column',
  ColumnHero = 'Column Hero',
  ContactColumn = 'Contact Column',
  ReverseColumnHero = 'Reverse Column Hero',
  ColumnWideImage = 'Column Wide Image',
  ReverseColumnWideImage = 'Reverse Column Wide Image',
  ReverseColumn = 'Reverse Column',
  CenteredSkinny = 'Centered Skinny',
  Left = 'Left',
  CenteredVideo = 'Centered Video',
  ColumnCenteredBackground = 'Column Centered Background',
}
export enum AlignmentVariants {
  Left = 'Left',
  Center = 'Center',
  Right = 'Right',
  Wide = 'Wide',
}
export enum BGVariants {
  White = 'White',
  DarkPrimary = 'Dark Primary',
  MediumPrimary = 'Medium Primary',
  LightPrimary = 'Light Primary',
  LightPaper = 'Light Paper',
  DarkPaper = 'Dark Paper',
  DarkPaper2 = 'Dark Paper 2',
  DarkSecondary = 'Dark Secondary',
  Grey = 'Grey',
  Black = 'Black',
}
export interface FeatureContent {
  contentful_id: string
  images: AssetFluid[]
}
export interface TextColumn {
  backgroundimage: AssetFluid
  contentful_id: string
  __typename: 'ContentfulTextColumn'
  name: string
  image: AssetFluid
  text: RichText
  variant: TextColumnVariant
  backgroundColor: BGVariants
  alignment: 'left' | 'center'
  codeClasses: string[] | null
  css: CssEntry[] | null
}

export enum TextColumnVariant {
  Small = 'small',
  SmallHighlight = 'small highlight',
  Medium = 'medium',
  Large = 'large',
  Flipped = 'flipped',
  Review = 'review',
  Logo = 'logo',
  Badge = 'badge',
  Hover = 'hover',
}

export interface TextColumnGroup {
  contentful_id: string
  __typename: 'ContentfulTextColumnGroup'
  textColumnArray: TextColumn[]
  variant: TextColumnGroupVariant
}
export enum TextColumnGroupVariant {
  Columns = 'Columns',
  Columns4 = 'Columns4',
  Carousel = 'Carousel',
  Masonry = 'Masonry',
  ColumnsMobile2 = 'ColumnsMobile2',
  ColumnsSeeMore = 'ColumnsSeeMore',
}

export interface StyledList {
  contentful_id: string
  variant: StyledListVariants
  __typename: 'ContentfulStyledList'
  listItems: ListItem[]
}

export interface RichListItem {
  contentful_id: string
  name: string
  text: RichText
  variant: string
  __typename: 'ContentfulRichListItem'
}

export interface ListItem {
  contentful_id: string
  name: string
  text: RichText
}

export enum StyledListVariants {
  Challenge = 'Challenge',
  Check = 'Check',
  KeyChanges = 'Key Changes',
  Bullet = 'Bullet',
}

export interface HeroTextSectionProps {
  displayClass: string
  titleClass: string
  row: HeroTextSection
  sectionClass?: string
}

export interface HeroTextTwoColumnSectionProps {
  displayClass?: string
  titleClass?: string
  row: HeroTextTwoColumnSection
  sectionClass?: string
}

export interface HoverText {
  contentful_id: string
  __typename: 'ContentfulHoverTextComponent'
  inlineText: string
  hoverText: string
}

export interface TimeChip {
  contentful_id: string
  __typename: 'ContentfulTimeChip'
  name: string
  time: string
  variant: TimeChipVariant
}

export enum TimeChipVariant {
  Highlighted = 'Highlighted',
}

export interface AccordionList {
  contentful_id: string
  __typename: 'ContentfulAccordionList'
  accordionItemArray: AccordionItem[]
}

export interface AccordionItem {
  contentful_id: string
  __typename: 'ContentfulAccordionItem'
  title: string
  body: RichText
}

export interface TabbedComponentProps {
  contentful_id: string
  __typename: 'ContentfulTabbedComponent'
  name: string
  imageInsertArray: (ImageInsert | VideoInsert)[]
}

export interface ImageToggle {
  contentful_id: string
  __typename: 'ContentfulImageToggle'
  name: string
  toggleLabels: string[]
  images: AssetFluid[]
}

export enum DeviceWidths {
  DesktopMaxWidth = 3450,
  DesktopMinWidth = 1439,
  LaptopMaxWidth = 1440,
  LaptopMinWidth = 1023,
  TabletMaxWidth = 1024,
  TabletMinWidth = 767,
  MobileMaxWidth = 768,
  MobileMinWidth = 319,
}
